export interface ChangeWorkOrderStageEstimatedStartDate {
	estimatedStartDate: Date;
	workOrderStageId: number;
}

export class ChangeWorkOrderStageEstimatedStartDate implements ChangeWorkOrderStageEstimatedStartDate {
	estimatedStartDate = new Date;
	
	constructor(data?: Partial<ChangeWorkOrderStageEstimatedStartDate>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}